/**
 * Lightweight structural check that a value looks like a JWS-format JWT
 * before we send it as a Bearer token.
 *
 * This guard exists because Spring's NimbusJwtDecoder rejects any non-JWT
 * value with the unhelpful "Malformed token" error. We'd rather catch
 * obviously-invalid tokens (undefined, null, opaque Microsoft Graph
 * tokens, empty strings, the literal strings "undefined"/"null"/etc.) at
 * the UI boundary and either omit the Authorization header entirely or
 * refuse to persist the value, so that the backend's 401 carries clearer
 * meaning ("no auth" instead of "malformed auth").
 *
 * Returns true only when `value` is a string that:
 *  - is non-empty,
 *  - starts with "eyJ" (the base64url encoding of the JOSE header `{"alg":...`), and
 *  - has exactly three `.`-separated segments (header.payload.signature).
 *
 * This is intentionally structural, not cryptographic: we don't verify
 * signatures or claims here — that's the resource server's job.
 */
export const isLikelyJwt = (value) =>
  typeof value === "string" &&
  value.length > 0 &&
  value.startsWith("eyJ") &&
  value.split(".").length === 3;
